/**
 * Elias route tree — chat-first, single route.
 *
 * Mirrors apps/web/src/ministry/routes.tsx but pared down: Elias is one
 * person, no admin sub-surface yet. Add /elias/admin if/when system
 * configuration moves out of the main N71 admin tab.
 *
 *   /elias        → EliasChatPage (full-screen chat with prominent
 *                                  document-upload landing)
 *   /elias/*      → bounce to /elias
 */

import { lazy } from "react";
import { Navigate, type RouteObject } from "react-router-dom";
import { EliasShell } from "./EliasShell";

const EliasChatPage = lazy(() =>
  import("./pages/EliasChatPage").then((m) => ({ default: m.EliasChatPage })),
);

export const eliasRoutes: RouteObject[] = [
  {
    path: "/elias",
    element: <EliasShell />,
    children: [
      { index: true, element: <EliasChatPage /> },
      // Any other /elias/* — bounce to chat. Mirrors the Ministry
      // catch-all so deep-links into future sub-surfaces (or stale
      // bookmarks) resolve to a working surface.
      { path: "*", element: <Navigate to="/elias" replace /> },
    ],
  },
];
